var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button big-button niveau-de-diff--relative",on:{"click":function($event){return _vm.callback(_vm.competence)}}},[_c('span',[_vm._v(_vm._s(_vm.competence.valeur))]),_c('repeater',{staticClass:"niveau-de-diff--absolute",attrs:{"courant":_vm.competence.niveau,"maximum":"4","li-css-custom":"niveau"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }